import script from "./Riskscore.vue?vue&type=script&setup=true&lang=js"
export * from "./Riskscore.vue?vue&type=script&setup=true&lang=js"

import "./Riskscore.vue?vue&type=style&index=0&id=19cbbb38&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19cbbb38"]])

export default __exports__